export const ECHO_EMOJIS = {
  challenge: '☁️',
  strength: '☀️'
}
